const get = require('lodash.get');

export const getData = obj => {

  var temp= get(obj, 'data.data', null);
  return temp;
};

export const getResData = obj => { let temp = get(obj, 'data', null); return temp; }
